module.exports = __webpack_public_path__ + "img/reward.de70aa9d.png";